






import Vue from 'vue'
import props from './props'
import style from './style.module.scss'

export default Vue.extend({
    name: 'button-common',
    components: {

    },
    props: {
        ...props as PropsObject
    },
    data() {
        return {
            style: style
        }
    },
    computed: {
        classList(): string[] {

            const classlist: string[] = [this.style.button]

            switch (this.size) {
                case 'xs':
                    classlist.push(this.style.buttonXs)
                    break;
                case 'mid':
                    classlist.push(this.style.buttonMid)
                    break;
                case 'lg':
                    classlist.push(this.style.buttonLg)
                    break;
            
                default:
                    break;
            }
            return classlist;
        }
    }
})
